import { render, staticRenderFns } from "./ExtendOtherNutrientsZinc.vue?vue&type=template&id=5d316c56&scoped=true"
import script from "./ExtendOtherNutrientsZinc.vue?vue&type=script&lang=ts"
export * from "./ExtendOtherNutrientsZinc.vue?vue&type=script&lang=ts"
import style0 from "./ExtendOtherNutrientsZinc.vue?vue&type=style&index=0&id=5d316c56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d316c56",
  null
  
)

export default component.exports